import React from "react"
import MenuCard from "./subcomponents/MenuCard"
import data from "./subcomponents/data.json"
import TestimonialCard from "./subcomponents/TestimonialCard"
import { Link } from "react-router-dom"
import 'aos/dist/aos.css';
import Aos from "aos"

export default function MainWebsite() {
    const [scrollState, changeScrollState] = React.useState(0)
    const [testimonialState, changeTestimonialState] = React.useState(0)
    let bestsellerArray = []

    data.map(menuData => {
        if (menuData.tags.includes("bestseller")) {
            bestsellerArray.push(1)
        }
    })  

    function changeBestsellersUp() {
        if (scrollState < (bestsellerArray.length - 1) * 1) {
            changeScrollState(prevState => prevState + 1)
        }
        
    }
    function changeBestsellersDown() {
        if (scrollState > 0) {
            changeScrollState(prevState => prevState - 1)
        }
    }

    function changeTestimonialUp() {
        if (window.innerWidth > 1350) {
            if (testimonialState < 3 ) {
                changeTestimonialState(prevState => prevState + 1)
            } 
        } else if (testimonialState < 7) {
            changeTestimonialState(prevState => prevState + 1)
        }
    }

    function changeTestimonialDown() {
        if (testimonialState !== 0) {
            changeTestimonialState(prevState => prevState - 1)
        }
    }

    const bestsellerCards = data.map((bestsellerData, index) => {
        if (bestsellerData.tags.includes("bestseller"))
        return (
            <MenuCard 
                header={bestsellerData.header}
                price={bestsellerData.price}
                description={bestsellerData.description}
                image={bestsellerData.image}
                key={index}
                delay={`${index}00`}
                animation="fade-up"
            />
        )
    })
    return (
        <main>
            <section className="main">
                <div className="mainInformation">
                    <h1 data-aos="fade-up" data-aos-once="true" data-aos-delay="500">Bon Sushi</h1>
                    <div className="mainButtons">
                        <div data-aos="fade-up" data-aos-once="true" data-aos-delay="700">
                            <Link to="/menu" className="mainButtonMenu">Menu</Link>
                        </div>
                        <div data-aos="fade-up" data-aos-once="true" data-aos-delay="700">
                            <Link to="/about" className="mainButtonAbout">About Us</Link>
                        </div>
                    </div>
                </div>
            </section>
            <section className="list">
                <div className="listItems">
                    <div className="listItem" data-aos="fade-up" data-aos-once="true" data-aos-delay="100">
                        <p className="listItemHeader">Fresh Made</p>
                        <p className="listItemDescription">Lorem ipsum dolor sit amet, elit adipiscing elit. </p>
                    </div>
                    <div className="listItemSeperation" data-aos="fade-up" data-aos-once="true" data-aos-delay="300"></div>
                    <div className="listItem listItem2" data-aos="fade-up" data-aos-once="true" data-aos-delay="300">
                        <p className="listItemHeader">Fresh Made</p>
                        <p className="listItemDescription">Lorem ipsum dolor sit amet, elit adipiscing elit. </p>
                    </div>
                    <div className="listItemSeperation" data-aos="fade-up" data-aos-once="true" data-aos-delay="500"></div>
                    <div className="listItem" data-aos="fade-up" data-aos-once="true" data-aos-delay="500">
                        <p className="listItemHeader">Fresh Made</p>
                        <p className="listItemDescription">Lorem ipsum dolor sit amet, elit adipiscing elit. </p>
                    </div>
                </div>
                
            </section>
            <section className="about">
                <div className="aboutInfo">
                    <h2 data-aos="fade-up" data-aos-once="true" data-aos-delay="100">Who We Are</h2>
                    <p data-aos="fade-up" data-aos-once="true" data-aos-delay="300">About Bon Sushi</p>
                    <div data-aos="fade-up" data-aos-once="true" data-aos-delay="500"></div>
                </div>
                <div className="aboutInfoDescription">
                    <p data-aos="fade-up" data-aos-once="true" data-aos-delay="700">Lorem ipsum dolor sit amet, consectetur adipiscing elit. Donec finibus eu magna vitae gravida. Nullam faucibus lobortis nisi a cursus. Morbi augue nisl, porta in nibh vestibulum orem ipsum dolor sit amet</p>
                </div>
            </section>
            <section className="bestsellers">
                <div className="decorationCircleContainer">
                    <div className="decorationCircle"></div>
                </div>
                <h3 data-aos="fade-up" data-aos-once="true" data-aos-delay="500">Our Bestsellers</h3>
                <div  className="decorationFullMenu" data-aos="fade-up" data-aos-once="true" data-aos-delay="300">
                    <Link to="/menu" className="decorationFullMenu2">Full Menu</Link>
                </div>
                
                <div className="bestsellerMenu">
                    <div className="bestsellerMenuChange" style={{left: `calc(var(--move-menu) * ${scrollState})`}}>
                        {bestsellerCards}
                    </div>
                </div>
                <div className="bestsellerChange">
                    <div className="bestsellerScrollArrow" onClick={changeBestsellersDown}>
                        <i className="fa-solid fa-angle-left bestsellerScrollArrowLogo"></i>
                    </div>  
                    <div className="bestsellerScroll">
                        <div className="bestsellerScrollColor" style={{width: `calc(${scrollState} * 425% / 4.25 / ${bestsellerArray.length - 1})`}}></div>
                    </div>
                    <div className="bestsellerScrollArrow bestsellerScrollArrowRight" onClick={changeBestsellersUp}>
                        <i className="fa-solid fa-angle-right bestsellerScrollArrowLogo"></i>
                    </div>
                </div>
            </section>
            <section className="testimonials">
                <h4 data-aos="fade-up" data-aos-once="true" data-aos-delay="100">What Our <span>Sushi Lovers</span> Say</h4>
                <div className="testimonialCardsContainer">
                    <div className="testimonialCards">
                        <div data-aos="fade-up" data-aos-once="true" data-aos-delay="300" data-aos-offset="-100">
                            <div className="testimonialArrow testimonialArrowLeft" onClick={changeTestimonialDown}>
                                <i className="fa-solid fa-angle-left testimonialArrowIcon"></i>
                            </div>
                        </div> 
                        <div className="testimonialCardSwipeContainer">
                            <div className="testimonialCardsSwipe" style={{left: `calc(var(--move-testimonials) * ${testimonialState})`}}>
                                <TestimonialCard 
                                    one={false}
                                    header="Kai Pereira"
                                    description="Lorem ipsum dolor sit amet, ectetur ading elit. Donec finibus eu magna vitae grvida. Null Par Sit Amet Ectetur Ading"
                                />
                                <TestimonialCard 
                                    header="Liam Watson"
                                    description="Lorem ipsum dolor sit amet, ectetur ading elit. Donec finibus eu magna vitae grvida. Null Par Sit Amet Ectetur Ading"
                                />
                                <TestimonialCard 
                                    header="Keira Wade"
                                    description="Lorem ipsum dolor sit amet, ectetur ading elit. Donec finibus eu magna vitae grvida. Null Par Sit Amet Ectetur Ading"
                                />
                                <TestimonialCard 
                                    header="Nora Simms"
                                    description="Lorem ipsum dolor sit amet, ectetur ading elit. Donec finibus eu magna vitae grvida. Null Par Sit Amet Ectetur Ading"
                                />
                                <TestimonialCard 
                                    header="Bethany Apps"
                                    description="Lorem ipsum dolor sit amet, ectetur ading elit. Donec finibus eu magna vitae grvida. Null Par Sit Amet Ectetur Ading"
                                />
                                <TestimonialCard 
                                    header="Elena Wright"
                                    description="Lorem ipsum dolor sit amet, ectetur ading elit. Donec finibus eu magna vitae grvida. Null Par Sit Amet Ectetur Ading"
                                />
                                <TestimonialCard 
                                    header="Luke Gole"
                                    description="Lorem ipsum dolor sit amet, ectetur ading elit. Donec finibus eu magna vitae grvida. Null Par Sit Amet Ectetur Ading"
                                />
                                <TestimonialCard 
                                    header="Mona Kim"
                                    description="Lorem ipsum dolor sit amet, ectetur ading elit. Donec finibus eu magna vitae grvida. Null Par Sit Amet Ectetur Ading"
                                />
                            </div>
                        </div>
                        <div className="testimonialArrowContainerResponsive" data-aos="fade-up" data-aos-once="true" data-aos-delay="700" data-aos-offset="-100">
                            <div className="testimonialArrow testimonialArrowExtra" onClick={changeTestimonialDown}>
                                <i className="fa-solid fa-angle-left testimonialArrowIcon"></i>
                            </div>
                            <div className="testimonialArrow testimonialArrow2" onClick={changeTestimonialUp}>
                                <i className="fa-solid fa-angle-right testimonialArrowIcon"></i>
                            </div>
                        </div>
                        
                    </div>  
                </div>
            </section>
            <section className="location">
                <div className="locationImageContainer">
                    <img src="location.png" alt="location" className="locationImage" loading="lazy"/>
                    <div className="locationFormContainer">
                        <div className="locationFormContainerAlign">
                            <form className="locationForm" data-aos="fade-up" data-aos-once="true" data-aos-delay="100">
                                <h5>Contact Us</h5>
                                <div className="locationFormData">
                                    <div className="locationFormElement">
                                        <input type="text" placeholder="Name" required/>
                                        <div></div>
                                    </div>
                                </div>
                                <div className="locationFormData">
                                    <div className="locationFormElement">
                                        <input type="email" placeholder="Email" required/>
                                        <div></div>
                                    </div>
                                </div>
                                <div className="locationFormData">
                                    <div className="locationFormElement">
                                        <input type="text" placeholder="Phone" required/>
                                        <div></div>
                                    </div>
                                </div>
                                <div className="locationFormData">
                                    <div className="locationFormElement">
                                        <input type="text" placeholder="Message" required/>
                                        <div></div>
                                    </div>
                                </div>
                                <div className="locationFormButtonAlign">
                                    <button>Submit</button>
                                </div>
                            </form>
                        </div>
                        
                    </div>
                </div>
            </section>
        </main>
    )
}